document.addEventListener('turbolinks:load', () => {
    if (!$('body.provider_profiles').length) return;

    $('input#provider_profile_avatar').change(function() {
        const reader = new FileReader();
        reader.onload = (event) => {
            $('img.avatar-preview').attr('src', event.target.result);
        };
        reader.readAsDataURL(this.files[0]);
    });

    window.resetPassword = function (providerId, token, passwordResetModal) {
        if (window.confirm("Are you sure you want to reset this user's password to a temporary password?")) {
            const csrfToken = document.querySelector('meta[name="csrf-token"]').getAttribute('content');

            $.post(
                `/en/admin/provider_profiles/${providerId}/reset_password`,
                {
                    token,
                    authenticity_token: csrfToken
                },
                (success) => {
                    const $passwordResetModal = $(passwordResetModal);
                    $passwordResetModal.find('.new-password').text(success.password);
                    $passwordResetModal.modal({show: true});
                })
                .fail(function(error) {
                    window.alert('Something went wrong.');
                });
        }
    };

    const $termsCheckboxes = $('.terms-checkbox');
    const $continueButton = $('#terms-continue-button');

    if ($termsCheckboxes.length > 0 && $continueButton.length > 0) {
        const locale = document.documentElement.lang || 'en';
        const tooltipMessages = {
            en: 'Please check all boxes to continue',
            es: 'Por favor, marque todas las casillas para continuar'
        };
        const tooltipMessage = tooltipMessages[locale] || tooltipMessages['en'];

        $continueButton.tooltip({
            title: tooltipMessage,
            placement: 'top',
            trigger: 'hover'
        });

        function validateTermsCheckboxes() {
            const allChecked = $termsCheckboxes.length === $termsCheckboxes.filter(':checked').length;

            if (allChecked) {
                $continueButton.removeClass('disabled').css('pointer-events', 'auto');
                $continueButton.tooltip('disable');
            } else {
                $continueButton.addClass('disabled').css('pointer-events', 'auto');
                $continueButton.tooltip('enable');
            }
        }

        $termsCheckboxes.on('change', validateTermsCheckboxes);
        $continueButton.on('click', function(e) {
            const allChecked = $termsCheckboxes.length === $termsCheckboxes.filter(':checked').length;
            if (!allChecked) {
                e.preventDefault();
                return false;
            }
            if (window.setFormSubmitting) {
                window.setFormSubmitting();
            }
        });
        validateTermsCheckboxes();
    }
});